import React from 'react';
import { Paper } from '@mui/material';
import MultiLangPlayer from '../common/MultiLangPlayer';

interface VideoPlayerSectionProps {
    setVideoDurationTime: (duration: number) => void;
}

const VideoPlayerSection: React.FC<VideoPlayerSectionProps> = ({ setVideoDurationTime }) => {
    return (
        <Paper elevation={2} className="video-info-tab__player-wrapper paper__elevation-2">
            <MultiLangPlayer setVideoDurationTime={setVideoDurationTime} />
        </Paper>
    );
};

export default VideoPlayerSection; 